import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const WatchlistItem = React.lazy(() =>
    import('../WatchlistItem')
);
const watchlistItemRoutesRegistry = [
    {
        path: PAGE_URL.WATCHLIST_ITEM_PAGE,
        element: <WatchlistItem />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default watchlistItemRoutesRegistry;
